<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <loader :loading="loadingCategories"/>

    <form-group label="Faixa Etária" :columns="3" :error="getError('ageGroup', product.productId)">
      <select v-model="product.ageGroup" class="form-select" :disabled="product.status === 'sent' || product.status === 'error'">
        <option :value=null>Escolha</option>
        <option value="adult">
          {{ $t('skyhub.ageGroup.adult.label') }}
        </option>
        <option value="kids">
          {{ $t('skyhub.ageGroup.kids.label') }}
        </option>
        <option value="both">
          {{ $t('skyhub.ageGroup.both.label') }}
        </option>
      </select>
    </form-group>

    <form-group label="Categorias" :columns="3" :error="getError('category', product.productId)" :required="true">
      <multiselect
        v-model="category"
        :options="categories"
        label="name"
        track-by="value"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-12@md" v-if="attributes.length">
      <div class="divider"><span>Atributos</span></div>
    </div>

    <form-group
      v-for="attribute in attributes"
      :key="attribute.id"
      :label="attribute.name"
      :columns="3"
      :error="getError(attribute.name, product.productId)"
      :required="attribute.required"
    >
      <template v-if="attribute.enum && attribute.enum.length">
        <multiselect
          v-model="attribute.value"
          :options="attribute.enum"
          label="name"
          track-by="value"
          :placeholder="attribute.name"
        />
      </template>

      <input
        v-else
        class="form-input"
        type="text"
        v-model="attribute.value"
      />
    </form-group>

  </shared-product-provide>
</template>

<script>
import { mapGetters } from 'vuex'
import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
import FormGroup from '@/components/template/FormGroup'
import api from '@/api'
import notifier from '@/notifier'
import Multiselect from 'vue-multiselect'
import Loader from '@/components/template/Loader'

export default {
  provide: {
    moduleDI: {
      type: 'marketplace',
      identifier: 'skyhub'
    },
    maxDescriptionLengthDI: 32767,
    allowDescriptionHtml: false
  },
  data: () => ({
    loadingCategories: false,
    category: null,
    categories: [],
    attributes: []
  }),
  props: {
    product: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    toModule: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.$parent.loadingProducts(false)
    this.loadingCategories = true

    api.skyhub.getCategories(this.partnerId)
      .then(categories => {
        this.categories = categories
        this.product.category = ''
      })
      .catch(() => {
        notifier.error('Impossível carregar as "Categorias" da Skyhub.', 'Erro')
      })
      .finally(() => {
        this.loadingCategories = false
      })
  },
  computed: {
    ...mapGetters('errors', [
      'getError'
    ]),
    ...mapGetters('module', [
      'getDefinitionModuleByIdentifierAndType'
    ]),
    moduleDefinition () {
      return this.getDefinitionModuleByIdentifierAndType('marketplace', 'skyhub')
    }
  },
  watch: {
    category (value) {
      if (value) {
        this.fillAttributes(value)
      }
    }
  },
  methods: {
    formatProduct () {
      return this.product.variations
        .filter(variation => variation.selected)
        .map(variation => {
          if (variation.attributes['color'] === undefined || variation.attributes['color'] === null) {
            variation.attributes['color'] = 'Única'
          }

          if (variation.attributes['size'] === undefined || variation.attributes['size'] === null) {
            variation.attributes['size'] = 'Único'

            if (variation.attributes.voltage !== undefined && variation.attributes.voltage !== null) {
              delete variation.attributes.size
            }

            if (variation.attributes['Anatel'] === undefined || variation.attributes['Anatel'] === null || variation.attributes['Anatel'] === '') {
              delete variation.attributes.Anatel
            }
          }

          this.attributes
            .map(attribute => {
              if (attribute.value === undefined && attribute.required) {
                this.addError({
                  productId: this.product.productId,
                  property: attribute.id,
                  error: {
                    message: 'required',
                    value: 1
                  }
                })
              }
            })

          const attributes = this.attributes
          .filter(attribute => {
            if (attribute.required === false) return false

            return (
              attribute.value !== undefined &&
              (typeof attribute.value === 'string' ? attribute.value.trim() !== '' : true)
            )
          })
          .map(attribute => {
            return {
              id: attribute.id,
              label: attribute.name,
              valueId: typeof attribute.value === 'object' ? attribute.value.value : attribute.value,
              valueLabel: attribute.value
            }
          })

          return {
            sku: variation.sku,
            title: this.product.title,
            description: this.product.description,
            stock: variation.stock,
            price: variation.price,
            source: this.fromModule,
            ean: variation.ean,
            images: variation.images.length ? variation.images : null,
            width: variation.width,
            height: variation.height,
            weight: variation.weight,
            length: variation.length,
            category: this.product.category.value,
            categories: this.product.categories,
            brand: this.product.brand,
            gender: variation.gender,
            ageGroup: this.product.ageGroup,
            productId: this.moduleDefinition.module.configs.product.singleVariation ? variation.sku : this.product.productId,
            attributes: attributes,
            crossDocking: {
              quantity: variation.crossDocking
            },
            color: variation.attributes['color'],
            original: {
              product: this.product,
              variation: variation
            }
          }
        }
      )
    },
    async fillAttributes (category) {
      this.loadingCategories = true

      api.skyhub.getCategoryAttributes(category.value)
        .then(attributes => {
          this.attributes = attributes
          this.category.attributes = ''
        })
        .catch(() => {
          notifier.error(`Impossível carregar atributos de "${category.name}".`, 'Erro')
        })
        .finally(() => {
          this.loadingCategories = false
        })
    }
  },
  components: {
    SharedProductProvide,
    Multiselect,
    Loader,
    FormGroup
  }
}
</script>

Product
Variation



// WEBPACK FOOTER //
// Product.vue?4c369650